module.exports = __webpack_public_path__ + "img/undraw_camping_noc8.88d4fdfa.svg";